import { useObjectDatesMapper } from './dateHelper';
import { AbstractTask } from '../Types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export function useTasksResponseMapper() {
  const {
    mapSingle: mapSingleBase,
  } = useObjectDatesMapper<AbstractTask>(
    [
      'dueDate.time',
      'dueDate.endTime',
      'dueDate.date',
      '_approximateDueDate',
    ],
    [
      'completedAt',
    ],
  );

  const mapSingle = (source: Record<string, any>): AbstractTask => {
    const mapped = mapSingleBase(source);

    return mapped;
  }

  const mapList = (source: Record<string, any>[]): AbstractTask[] => {
    return source.map(mapSingle);
  }


  return {
    mapSingle,
    mapList,
  };
}
